import { useId } from 'react';

import { QuestionTextRenderer } from '@/components/QuestionTextRenderer/QuestionTextRenderer';

/**
 * Props for SectionTitleQuestionAnswer
 */
export interface SectionTitleQuestionAnswerUIProps {
    /** Section title text displayed as a header */
    title?: string;
    /** Optional custom class for layout or spacing overrides */
    className?: string;
    /** Heading level for semantic structure (default: h2) */
    as?: 'h1' | 'h2' | 'h3' | 'h4';
    /** Selected values (unused for section titles, for interface consistency) */
    selectedValues?: string[];
    /** Change handler (unused for section titles, for interface consistency) */
    onChange?: (values: string[]) => void;
}

/**
 * UI-only component.
 * Displays a section title inside a survey.
 * Non-answerable. No callbacks or state.
 */
export const SectionTitleQuestionAnswer = ({
    title = '',
    className = '',
    as = 'h2',
}: SectionTitleQuestionAnswerUIProps) => {
    const HeadingTag = as;
    const titleId = useId();

    return (
        <section
            role={'region'}
            aria-labelledby={titleId}
            className={`flex items-center justify-center py-8 ${className}`}
        >
            <HeadingTag
                id={titleId}
                className={'text-center text-2xl font-semibold text-white sm:text-3xl'}
            >
                <QuestionTextRenderer text={title} />
            </HeadingTag>
        </section>
    );
};
